import React from 'react';
import PropTypes from 'prop-types';
import NotificationModal from 'base/components/NotificationModal';
import PrimaryCta from 'base/components/PrimaryCta';

class CartItemsExpiredNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func
  };

  render() {
    return (
      <NotificationModal
        title="Uh oh! That's not an option"
        body="The items already in your cart are currently unavailable.
          You can continue by emptying your cart to start a new order."
        onClose={this.props.closeModal}
      >
        <PrimaryCta
          label="Yes, Empty my cart"
          handleClick={this.props.handlePrimaryCta}
          fullWidth
        />
      </NotificationModal>
    );
  }
}

export default CartItemsExpiredNotification;
